// src/api/objectiveTrials/objectiveTrials.ts
import { useApiClient } from "../apiClients";
import { OBJECTIVE_TRIALS_ENDPOINTS } from "./endpoints";
import type {
  ObjectiveTrial,
  ObjectiveTrialDetail,
  ObjectiveTrialEstimate,
  ObjectiveTrialPayload,
} from "../../models/domain";

export const useObjectiveTrialsApi = () => {
  const apiClient = useApiClient("embed");

  /** `override: {}` rend le réglage effectif de la matière : de quoi préremplir. */
  const estimateObjectiveTrial = (payload: ObjectiveTrialPayload) =>
    apiClient.post<ObjectiveTrialEstimate>(OBJECTIVE_TRIALS_ENDPOINTS.ESTIMATE, payload);

  const createObjectiveTrial = (payload: ObjectiveTrialPayload) =>
    apiClient.post<{ trial: ObjectiveTrial }>(OBJECTIVE_TRIALS_ENDPOINTS.BASE, payload);

  const listObjectiveTrials = () => apiClient.get<{ trials: ObjectiveTrial[] }>(OBJECTIVE_TRIALS_ENDPOINTS.BASE);

  const getObjectiveTrial = (id: string) => apiClient.get<ObjectiveTrialDetail>(OBJECTIVE_TRIALS_ENDPOINTS.DETAIL(id));

  const applyObjectiveTrial = (id: string) => apiClient.post<{ trial: ObjectiveTrial }>(OBJECTIVE_TRIALS_ENDPOINTS.APPLY(id));

  /** Un essai en cours est arrêté puis jeté ; appliqué ou en application, il ne se jette pas (409). */
  const discardObjectiveTrial = (id: string) => apiClient.delete<{ trial: ObjectiveTrial }>(OBJECTIVE_TRIALS_ENDPOINTS.DETAIL(id));

  return {
    estimateObjectiveTrial,
    createObjectiveTrial,
    listObjectiveTrials,
    getObjectiveTrial,
    applyObjectiveTrial,
    discardObjectiveTrial,
  };
};
